import { PKG } from '../../analytics/analyticsConsts';
import {
  REAPPLICATION_ACCOUNT_STATUS,
  setOfferPageForCard,
} from '../../api/api';
import {
  setLoading,
  setShowPreSignupStatus,
} from '../../app/applicationScreenSlice';
import { setApplicationUUID } from '../../app/applicationStatusSlice';
import { prefillConsumerProfileFromHome } from '../../app/consumerInfoSlice';
import { AppHistory } from '../../app/History';
import { SCREEN, setScreen } from '../../app/screenStateSlice';
import { AppDispatch, store } from '../../app/store';
import { ANALYTICS } from '../../firebase/firebase';
import {
  AccountStatus,
  Actions,
  ActionType,
  ProductAccount,
} from '../../types';
import { reApplicationSetUpAfterHome } from '../../utils/functionUtils';
import { PAGE } from '../../utils/routeConstant';

const handlePendingOffer = (
  dispatch: AppDispatch,
  productUUID: string,
  applicationUUID: string
) => {
  dispatch(setOfferPageForCard(productUUID, applicationUUID));
  dispatch(setScreen(SCREEN.OFFER));
  AppHistory.navigate?.(PAGE.OFFER);
};

const handleRejected = (
  dispatch: AppDispatch,
  action: Actions,
  canApply: boolean
) => {
  if (action.params.applicationUUID) {
    dispatch(setApplicationUUID(action.params.applicationUUID));
  }

  if (canApply === true) {
    reApplicationSetUpAfterHome(dispatch);
  } else {
    dispatch(setScreen(SCREEN.APPLICATION_NOT_APPROVED));
  }
};

const parseActions = (actions: Actions[]) => {
  const currMerchantProductUUID =
    store.getState().merchantDataSelector.productUUID;
  const homeResponse = store.getState().homeSelector;
  const dispatch = store.dispatch;
  let hasMerchantAction = false;

  for (const action of actions) {
    if (!action.params || !action.type) {
      continue;
    }

    const { productUUID } = action.params;

    if (productUUID !== currMerchantProductUUID) {
      continue;
    }

    hasMerchantAction = true;
    switch (action.type) {
      case ActionType.ShowExpiredApplicationScreen:
        reApplicationSetUpAfterHome(
          dispatch,
          homeResponse,
          REAPPLICATION_ACCOUNT_STATUS.EXPIRED_OFFER
        );
        dispatch(setScreen(SCREEN.APPLICATION));
        break;
      case ActionType.ShowOfferScreen:
        handlePendingOffer(
          dispatch,
          action.params.productUUID,
          action.params.applicationUUID
        );
        break;
      case ActionType.ShowRejectionScreen:
        handleRejected(
          dispatch,
          action,
          homeResponse.creditAccount?.canApply === true
        );
        break;
      default:
        ANALYTICS.funcError(
          PKG,
          'parseActions',
          `unexpected action type: ${action.type}`
        );
        dispatch(setScreen(SCREEN.ACCOUNT_PENDING));
        break;
    }
  }

  return hasMerchantAction;
};

const parseProductAccounts = (productAccounts: ProductAccount[]) => {
  let hasProductAccount = false;
  const merchantData = store.getState().merchantDataSelector;
  const dispatch = store.dispatch;

  const currMerchantProductUUID = merchantData.productUUID;

  for (const productAccount of productAccounts) {
    const { productUUID, productAccountStatus } = productAccount;

    if (productUUID !== currMerchantProductUUID) {
      continue;
    }

    hasProductAccount = true;
    switch (productAccountStatus) {
      case AccountStatus.Active:
        dispatch(setShowPreSignupStatus(true));
        dispatch(setScreen(SCREEN.APPLICATION_ACTIVE_USER));
        break;
      case AccountStatus.ManualReview:
        dispatch(setScreen(SCREEN.APPLICATION_IN_REVIEW));
        break;
      case AccountStatus.Frozen:
        reApplicationSetUpAfterHome(dispatch);
        dispatch(setScreen(SCREEN.CREDIT_FROZEN));
        break;
      case AccountStatus.OfferPending:
        if (!productAccount.params?.applicationUUID) {
          // what should we do here? is this possible?
          continue;
        }

        handlePendingOffer(
          dispatch,
          productAccount.productUUID,
          productAccount.params?.applicationUUID
        );
        break;
      default:
        ANALYTICS.funcError(
          PKG,
          'parseProductAccounts',
          `unexpected status: ${productAccountStatus}`
        );
        dispatch(setScreen(SCREEN.ACCOUNT_PENDING));
        break;
    }
  }

  return hasProductAccount;
};

export const handleLoadHomeSuccess = ({
  isReapplication,
}: {
  isReapplication?: boolean;
}) => {
  const home = store.getState().homeSelector;
  const dispatch = store.dispatch;

  // prefill
  dispatch(prefillConsumerProfileFromHome(home.userInformation));
  if (isReapplication) {
    return;
  }

  let result = false;

  // parse actions to see if offer is pending
  if (home.actions) {
    result = parseActions(home.actions);
  }

  // parse product accounts to see if offer is pending
  if (home.productAccounts) {
    result = parseProductAccounts(home.productAccounts);
  }

  // only want to run these if nothing happened in parseActions or parseProductAccounts
  if (!result) {
    reApplicationSetUpAfterHome(dispatch);
    dispatch(setScreen(SCREEN.APPLICATION));
    dispatch(setLoading(false));
  }
};
